import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { SectionLabel } from "@/components/SectionLabel";
import { SCHEDULE_DAYS } from "@/data/eventData";

const SchedulePreview = () => (
    <section id="schedule" data-testid="schedule-preview-section" className="scroll-mt-24 bg-coal/50 py-24 md:py-36">
        <div className="mx-auto max-w-[1400px] px-5 md:px-10">
            <Reveal>
                <SectionLabel index="06" text="The Schedule" />
            </Reveal>
            <Reveal delay={0.1}>
                <h2 className="mt-8 font-serif text-4xl font-light leading-[1.05] tracking-tight text-cream sm:text-5xl lg:text-6xl">
                    Two Days.
                    <br />
                    Infinite <em className="italic text-scarlet">Ideas.</em>
                </h2>
            </Reveal>

            <div className="mt-14 grid gap-5 md:grid-cols-2 md:gap-8">
                {SCHEDULE_DAYS.map((day, i) => (
                    <Reveal key={day.id} delay={0.15 + i * 0.1}>
                        <div className="group relative border border-cream/5 bg-ink p-8 transition-colors duration-500 hover:border-crimson/50 md:p-12">
                            <span className="font-sans text-[11px] font-semibold uppercase tracking-[0.35em] text-scarlet">
                                {day.day}
                            </span>
                            <p className="mt-5 font-serif text-3xl font-light italic leading-snug text-cream md:text-4xl">
                                {day.tagline}
                            </p>
                            <p className="mt-6 text-sm font-light text-ash">
                                {day.date} · timings to be announced
                            </p>
                        </div>
                    </Reveal>
                ))}
            </div>

            <Reveal delay={0.25}>
                <Link
                    to="/schedule"
                    data-testid="view-full-schedule-btn"
                    className="group mt-12 inline-flex w-full items-center justify-center gap-3 border border-cream/15 px-8 py-4 font-sans text-[11px] font-semibold uppercase tracking-[0.25em] text-cream transition-colors duration-300 hover:border-crimson hover:bg-maroon/50 sm:w-auto"
                >
                    View Full Schedule
                    <ArrowRight className="h-4 w-4 text-scarlet transition-transform duration-300 group-hover:translate-x-1.5" />
                </Link>
            </Reveal>
        </div>
    </section>
);

export default SchedulePreview;
